import { props as dialogProps } from "#ce/components/SpDialog/props.js";
import { booleanAttribute } from "#ce/utils/props";

// sp-modal extends the sp-dialog prop contract with its own layout props.
// Object.freeze() guards against accidental mutation (a bug we hit in the past).
export const props = Object.freeze({
  ...dialogProps,
  modalTitle: {
    type: String,
    default: undefined,
  },
  titleOneline: booleanAttribute(true),
  subtitle: {
    type: String,
    default: undefined,
  },
  closeable: booleanAttribute(undefined),
  /**
   * Test id forwarded to the close button, so a journey that opens the modal
   * can also close it.
   *
   * @type {String}
   * @default undefined
   */
  closeTestId: {
    type: String,
    default: undefined,
  },
  /**
   * Clip the card body instead of letting it scroll. By default the body scrolls when its content overflows, keeping the header and actions pinned.
   *
   * @type {Boolean|String}
   * @default false
   */
  noScrollableContent: booleanAttribute(),
  /**
   * Whether the modal should represent a bottom sheet in mobile view.
   * If `true`, the modal will not be displayed as a bottom sheet in mobile view.
   *
   * @type {Boolean|String}
   * @default false
   */
  noBottomSheet: booleanAttribute(),
  /**
   * Whether the modal should have no content padding.
   * If `true`, the modal will have no content padding.
   *
   * @type {Boolean|String}
   * @default false
   */
  noMobileContentPadding: booleanAttribute(),
  /**
   * Whether the modal should expand to full height.
   * If `true`, the modal will expand to full height.
   *
   * @type {Boolean|String}
   * @default false
   */
  expandToFullHeight: booleanAttribute(),
  /**
   * Whether the modal should expand to maximum height.
   * If `true`, the modal will expand to maximum height.
   *
   * @type {Boolean|String}
   * @default false
   */
  expandHeightMax: booleanAttribute(),
});
